import { createContext } from 'react'

type IconCacheContext = {
  icons: { [iconUrl: string]: string }
  loading: string[]
  cacheIcon: (path: string, icon: string) => void
  startLoadingIcon: (path: string) => boolean
}

export const IconCache = createContext<IconCacheContext>({
  icons: {},
  loading: [],
  cacheIcon: () => undefined,
  startLoadingIcon: () => false
})
